import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import VideocamIcon from "@mui/icons-material/Videocam";
import axios from "./../../../../axios";
import { EditIcon, X } from "lucide-react";
import { hasFeature } from "../../../../Utils/features";
import CreateClassLink from "../../../../DCM/components/CreateClassLink/CreateClassLink";

function BBBLectureCard({ data, supplement, setDeleteConfirm, send, date }) {
  const [broadcastLink, setBroadcastLink] = useState([]);
  const [noOnlineSession, setNoOnlineSession] = useState([]);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);
  const userinfo = JSON.parse(localStorage.getItem("UserInformation"));
  const handleSupplementDelete = () => {
    setDeleteConfirm(true);
    send({
      type: "bbbLecture",
      supplement,
    });
  };

  const has2WayLecture =
    hasFeature("OL_LEC_2W_NR") || hasFeature("OL_LEC_2W_WR");

  const isBroadcast = userinfo?.school?.liveClassType === "broadcast";

  const handleOnlineSession = async (bbbClass_id) => {
    if (!bbbClass_id) return;
    const UrlToFetch = has2WayLecture
      ? `api/v1/videoConference/classes/getCloudRecordingUrls/${bbbClass_id}`
      : isBroadcast
        ? `api/v1/videoConference/classes/getRecording/${bbbClass_id}`
        : `api/v1/videoConference/classes/getCloudRecordingUrls/${bbbClass_id}`;

    try {
      const response = await axios.get(UrlToFetch);

      if (response?.data?.data?.length > 0) {
        setBroadcastLink(response.data.data);
      } else {
        setNoOnlineSession(response?.data?.message || "No recordings found");
      }
    } catch (error) {
      console.error("Recording fetch error", error);
    }
  };

  console.log("Broadcast Link:", broadcastLink);

  const bbbId = data?.id;

  useEffect(() => {
    handleOnlineSession(bbbId);
  }, [bbbId]);

  const durationSeconds = Number(data?.duration) || 0;
  const durationMinutes = Math.floor(durationSeconds / 60);

  const isDateLessThanCurrent = (dateString) => {
    if (!dateString) return false;

    const passedDate = new Date(dateString);
    const currentDate = new Date();

    return passedDate < currentDate;
  };

  const handleEditClick = async () => {
    try {
      let res = await axios.get(
        `/api/v1/videoConference/classes/getInfo?class_id=${data?.id}`,
      );

      if (res?.data?.status) {
        setEditData(res?.data?.data);
        setOpenEditPopup(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(editData, "editData");

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        mb: 2,
        boxShadow: 2,
        width: "80%",
        minHeight: 80,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <CardContent sx={{ py: 0.5, px: 2 }}>
        {/* Header */}
        <Typography
          variant="subtitle2"
          fontWeight={600}
          color="primary.main"
          gutterBottom
          sx={{ mb: 0.5 }}
        >
          Live Lecture
        </Typography>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Left Side */}
          <Stack
            direction="column"
            spacing={0.5}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              p: 1,
              width: 250,
            }}
          >
            {/* Header: Icon + Name */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.2}
              sx={{ cursor: "pointer" }}
            >
              <LiveTvIcon color="error" fontSize="small" />
              <Typography variant="body2" fontWeight={500}>
                {data?.name}
              </Typography>
            </Stack>
            {Array.isArray(broadcastLink) && broadcastLink.length > 0 && (
              <Stack
                direction="row"
                spacing={1}
                sx={{ cursor: "pointer" }}
                onClick={() => setShowPopUp(true)}
              >
                <VideocamIcon color="error" fontSize="small" />
                <Typography variant="body2" fontWeight={500}>
                  View Recording
                </Typography>
              </Stack>
            )}

            {data?.description && (
              <div className="d-flex flex-row align-items-center gap-2">
                <span className=""> Description :</span>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontStyle: "italic" }}
                >
                  {data.description}
                </Typography>
              </div>
            )}

            {/* Duration (only if > 0) */}
            {durationMinutes > 0 && (
              <Typography variant="caption" color="text.secondary">
                Duration: {durationMinutes} min
              </Typography>
            )}
          </Stack>

          {/* Right Side (Delete Button) */}
          <Stack direction="column" spacing={1}>
            {/* Edit Button */}
            {!isDateLessThanCurrent(date) && (
              <IconButton
                onClick={handleEditClick}
                color="primary"
                size="small"
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}

            {/* Delete Button */}
            {!isDateLessThanCurrent(date) && (
              <IconButton
                onClick={() => handleSupplementDelete(data)}
                color="error"
                size="small"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </Stack>
      </CardContent>
      {openEditPopup && editData && (
        <CreateClassLink
          setClick1={setOpenEditPopup}
          event={data}
          editData={editData}
          isEdit={true}
        />
      )}
      {showPopUp && (
        <div className="ContainerSubmitedSucess2">
          <div className="SubContainerSubmitedSucessBoradcast">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="text-blue-950 font-semibold">Online Session</h4>
              <div className="mb-2 cursor-pointer">
                <X
                  color="black"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowPopUp(false);
                  }}
                />
              </div>
            </div>
            <div>
              <iframe
                src={broadcastLink[0]}
                width="900"
                height="500"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}

export default BBBLectureCard;
